import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef,
  AfterContentInit,
  AfterViewChecked,
  ElementRef,
  Input,
} from '@angular/core';
@Component({
  selector: 'jsg-single-row-panel',
  templateUrl: './single-row-panel.component.html',
  styleUrls: ['./single-row-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleRowPanelComponent
  implements OnInit, AfterViewChecked, AfterViewInit {
  @Input() backgroundStyleClass: string;
  @Input() alignItemsH: 'start' | 'center' | 'space-between' = 'start';
  @Input() alignItemsV: 'start' | 'center' | 'space-between' = 'start';
  isSecondContentVisible: boolean = true;
  isThirdContentVisible: boolean = true;
  isForthContentVisible: boolean = true;
  @ViewChild('ref', { static: false }) div: ElementRef;
  constructor(private _cd: ChangeDetectorRef) {}
  ngAfterViewInit(): void {
    if (!this.backgroundStyleClass)
      this.backgroundStyleClass = 'section-background';
  }
  ngAfterViewChecked(): void {
    this.isSecondContentVisible = this.getContentVisibility(this.div, 1);
    this.isThirdContentVisible = this.getContentVisibility(this.div, 2);
    this.isForthContentVisible = this.getContentVisibility(this.div, 3);
    this._cd.markForCheck();
    this._cd.detectChanges();
  }

  ngOnInit(): void {}

  public getContentVisibility = (div: ElementRef, index: number): boolean => {
    return div?.nativeElement?.children[index]?.children?.length == 1;
  };
}
